import React, { useEffect } from 'react';
import * as _ from 'lodash';
import {getJsonQueryString, updateQueryStringParam} from '../common/utils';
import { CIG_SSO } from '../common/constants';

//TODO: No need it.
export function CigLogout() {

    useEffect(() => {
        if (!_.isUndefined(window.auth)) {
            const queryStr = getJsonQueryString();
            const opts = {
                cbInfo: _.get(queryStr, CIG_SSO.cookiesKey, '')
            };
            let logoutUrl = window.location.origin + '/logout';
            logoutUrl =  (!_.isEmpty(opts) ? updateQueryStringParam(logoutUrl, CIG_SSO.logout, opts.cbInfo) :  logoutUrl);
            logoutUrl = updateQueryStringParam(logoutUrl, null, 'federated');
            window.open(logoutUrl, '_self');
        }
    }, []);

    return (
        <div></div>
    );
}

CigLogout.displayName = 'CigLogout';
export default CigLogout;
